import type { AutoSpinSnapshot } from "./AutoSpinTypes";

export class AutoSpinStore {
  private snapshot: AutoSpinSnapshot = {
    popupOpen: false,
    selectedCount: null,
    remainingCount: 0,
    running: false,
  };

  private readonly listeners = new Set<(snapshot: AutoSpinSnapshot) => void>();

  public getSnapshot(): AutoSpinSnapshot {
    return this.snapshot;
  }

  public openPopup(): void {
    if (this.snapshot.running) {
      return;
    }

    this.snapshot = {
      ...this.snapshot,
      popupOpen: true,
    };
    this.emit();
  }

  public closePopup(): void {
    this.snapshot = {
      ...this.snapshot,
      popupOpen: false,
    };
    this.emit();
  }

  public setSelectedCount(count: number): void {
    this.snapshot = {
      ...this.snapshot,
      selectedCount: count,
    };
    this.emit();
  }

  public start(): void {
    if (!this.snapshot.selectedCount || this.snapshot.selectedCount <= 0) {
      return;
    }

    this.snapshot = {
      ...this.snapshot,
      popupOpen: false,
      running: true,
      remainingCount: this.snapshot.selectedCount,
    };
    this.emit();
  }

  public stop(): void {
    if (!this.snapshot.running && this.snapshot.remainingCount === 0) {
      this.closePopup();
      return;
    }

    this.snapshot = {
      ...this.snapshot,
      popupOpen: false,
      running: false,
      remainingCount: 0,
    };
    this.emit();
  }

  public consumeOne(): void {
    if (!this.snapshot.running || this.snapshot.remainingCount <= 0) {
      return;
    }

    const nextRemaining = this.snapshot.remainingCount - 1;

    this.snapshot = {
      ...this.snapshot,
      running: nextRemaining > 0,
      remainingCount: nextRemaining,
    };
    this.emit();
  }

  public subscribe(listener: (snapshot: AutoSpinSnapshot) => void): () => void {
    this.listeners.add(listener);
    listener(this.snapshot);
    return () => this.listeners.delete(listener);
  }

  private emit(): void {
    for (const listener of this.listeners) {
      listener(this.snapshot);
    }
  }
}